import React from 'react';
import PropTypes from 'prop-types';

import AdminReportsDataListItemGeneral from './DataListItemGeneral';
import AdminReportsDataListItemCollection from './DataListItemCollection';
import AdminReportsDataListItemFile from './DataListItemFile';
import AdminReportsDataListItemUser from './DataListItemUser';
import AdminReportsDataListItemTeam from './DataListItemTeam';
import AdminReportsDataListItemDownload from './DataListItemDownload';

const listItemComponents = [];
listItemComponents.collection = AdminReportsDataListItemCollection;
listItemComponents.file = AdminReportsDataListItemFile;
listItemComponents.user = AdminReportsDataListItemUser;
listItemComponents.team = AdminReportsDataListItemTeam;
listItemComponents.download = AdminReportsDataListItemDownload;

const AdminReportsDataListItem = ({
  item,
  columns,
  inWidget,
}) => (
  <tr>
    {Object.keys(columns).map((index) => {
      const DataListItem = listItemComponents[index] || AdminReportsDataListItemGeneral;

      return (
        <DataListItem
          key={index}
          index={index}
          item={item[index] || item}
          inWidget={inWidget}
        />
      );
    })}
  </tr>
);

AdminReportsDataListItem.propTypes = {
  item: PropTypes.object.isRequired,
  columns: PropTypes.object.isRequired,
  inWidget: PropTypes.bool,
};

AdminReportsDataListItem.defaultProps = {
  inWidget: false,
};

export default AdminReportsDataListItem;
